export * from "./triPlanarMaterial.js";
//# sourceMappingURL=index.js.map